export let colors = [
  {
    name: 'Salmon',
    color: '#FA8072',
  },
  {
    name: 'Lighsalmon',
    color: '#FFA07A',
  },
  {
    name: 'Crimson',
    color: '#DC143C',
  },
  {
    name: 'Hotpink',
    color: '#FF69B4',
  },
  {
    name: 'Deeppink',
    color: '#FF1493',
  },
  {
    name: 'Coral',
    color: '#FF7F50',
  },
  {
    name: 'Orangered',
    color: '#FF4500',
  },
  {
    name: 'Khaki',
    color: '#F0E68C',
  },
  {
    name: 'Violet',
    color: '#EE82EE',
  },
  {
    name: 'Orchid',
    color: '#DA70D6',
  },
  {
    name: 'Magenta',
    color: '#FF00FF',
  },
  {
    name: 'Blueviolet',
    color: '#8A2BE2',
  },
  {
    name: 'Slateblue',
    color: '#6A5ACD',
  },
  {
    name: 'Mediumspringgreen',
    color: '#00FA9A',
  },
  {
    name: 'Yellowgreen',
    color: '#9ACD32',
  },
  {
    name: 'Lightseagreen',
    color: '#20B2AA',
  },
  {
    name: 'Turquoise',
    color: '#40E0D0',
  },
  {
    name: 'Deepskyblue',
    color: '#00BFFF',
  },
  {
    name: 'Navajowhite',
    color: '#FFDEAD',
  },
  {
    name: 'Silver',
    color: '#C0C0C0',
  },
];
